import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
import { settingsAPI } from '@/lib/api';

const Footer = () => {
  const [settings, setSettings] = useState({
    logo_url: 'https://customer-assets.emergentagent.com/job_career-destination/artifacts/pnqixpyi_arya_mohajer_asia_logo.png',
    phone: '+98 21 1234 5678',
    email: 'info@aryamohajer.com',
    address_fa: 'تهران، ایران',
    instagram: '#',
    twitter: '#',
    linkedin: '#',
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await settingsAPI.get();
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 mt-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="relative overflow-hidden rounded-lg inline-block group cursor-pointer mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_career-destination/artifacts/ysupexoy_WhatsApp%20Image%202026-07-12%20at%2016.22.11.jpeg"
                alt="ARYA MOHAJER ASIA" 
                className="h-16 w-auto object-contain transition-all duration-500 ease-out group-hover:scale-110 group-hover:brightness-110"
              />
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/0 via-[#D4AF37]/30 to-[#D4AF37]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed">
              {settings.description_fa || 'مرجع کامل اطلاعات مهاجرت، تحصیل و کار در کشورهای مختلف جهان'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">دسترسی سریع</h3>
            <ul className="space-y-2">
              <Link to="/countries" className="block text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors">کشورها</Link>
              <Link to="/universities" className="block text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors">دانشگاه\u200cها</Link>
              <Link to="/jobs" className="block text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors">فرصت\u200cهای شغلی</Link>
              <Link to="/services" className="block text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors">خدمات</Link>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">خدمات ما</h3>
            <ul className="space-y-2">
              <li className="text-sm text-zinc-400">مشاوره مهاجرت تحصیلی</li>
              <li className="text-sm text-zinc-400">اخذ پذیرش دانشگاه</li>
              <li className="text-sm text-zinc-400">ویزای تحصیلی و کاری</li>
              <li className="text-sm text-zinc-400">رزرو هتل و پرواز</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">تماس با ما</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <Phone size={16} className="text-[#D4AF37]" />
                <span>{settings.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <Mail size={16} className="text-[#D4AF37]" />
                <span>{settings.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-zinc-400">
                <MapPin size={16} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <span>تهران، ایران</span>
                  <span>آنکارا، ترکیه</span>
                </div>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              {settings.instagram && (
                <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#D4AF37] hover:bg-white/10 transition-colors">
                  <Instagram size={18} />
                </a>
              )}
              {settings.twitter && (
                <a href={settings.twitter} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#D4AF37] hover:bg-white/10 transition-colors">
                  <Twitter size={18} />
                </a>
              )}
              {settings.linkedin && (
                <a href={settings.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#D4AF37] hover:bg-white/10 transition-colors">
                  <Linkedin size={18} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-sm text-zinc-500">
            © 2026 ARYA MOHAJER ASIA. تمامی حقوق محفوظ است.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
